import { render } from "./LeadsToolsCard.vue?vue&type=template&id=64a81a22"
import script from "./LeadsToolsCard.vue?vue&type=script&lang=js"
export * from "./LeadsToolsCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__